import React, { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const PARTICLES_STYLE = {
  particles: {
    number: {
      value: 800,
      density: { enable: true, value_area: 1000 },
    },
    color: { value: "#ffffff" },
    shape: {
      type: "circle",
      polygon: { nb_sides: 5 },
    },
    opacity: {
      value: {
        min: 0.2,
        max: 0.4,
      },
      animation: {
        enable: true,
        speed: 0.2,
        min: 0.1,
        sync: false,
      },
    },
    size: {
      value: {
        min: 0.2,
        max: 1.4,
      },
    },
    links: {
      enable: true,
      distance: 40,
      color: "#ffffff",
      opacity: 0.02,
      width: 1,
    },
    move: {
      enable: false,
    },
  },
  retina_detect: true,
  fpsLimit: 24,
};

export default function ParticlesBackground() {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  if (init) {
    return <Particles id="tsparticles" options={PARTICLES_STYLE} />;
  }

  return <div id="tsparticles" />;
}
